const HomeAdmin = () => {
    return (
        <div>
            Admin Home
        </div>
    );
}

export default HomeAdmin;